import { render, staticRenderFns } from "./CommodityContainer.vue?vue&type=template&id=3b1b8355&"
import script from "./CommodityContainer.vue?vue&type=script&lang=js&"
export * from "./CommodityContainer.vue?vue&type=script&lang=js&"
import style0 from "./CommodityContainer.vue?vue&type=style&index=0&id=3b1b8355&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports